export default __webpack_public_path__ + "static/media/img3.46afdc3d.jpg";